import { useEffect, useState } from 'react';
import Accordion from '../Accordion';
import SurroundingsMapCheckBox from './CheckBox';

import { VillageSurrounding } from '@/services/types';
import { ISurroundingsMapDictionary } from '@/dictionaries/components/surroundingsMap/types';

type Props = {
  dict: ISurroundingsMapDictionary;
  mapMarkersSurroundings: VillageSurrounding[];
  villageSurroundings: VillageSurrounding[];
  onCheckBoxChange: (surroundings: VillageSurrounding[]) => void;
};

export default function SightsCheckBoxes({
  dict,
  mapMarkersSurroundings,
  onCheckBoxChange,
  villageSurroundings,
}: Props) {
  const [showSights, setShowSights] = useState(true);
  const [showCities, setShowCities] = useState(true);
  const [showAttractions, setShowAttractions] = useState(true);
  const [showBeaches, setShowBeaches] = useState(true);
  const [showSuperMarkets, setShowSuperMarkets] = useState(false);
  const [showRestaurants, setShowRestaurants] = useState(false);
  const toggleSights = () => setShowSights((prev) => !prev);

  const { sights } = dict;

  function containsSurroundingType(type: string) {
    return (
      villageSurroundings.filter(
        ({ surrounding }) => surrounding.placeCategory.code === type,
      ).length > 0
    );
  }

  function handleFilterCheckboxChanges(
    placeCategoryCode: string,
    isChecked: boolean,
  ) {
    if (isChecked) {
      const categorySurroundings = villageSurroundings.filter(
        ({ surrounding }) => {
          return surrounding.placeCategory.code === placeCategoryCode;
        },
      );
      onCheckBoxChange([...mapMarkersSurroundings, ...categorySurroundings]);
    } else {
      onCheckBoxChange(
        mapMarkersSurroundings.filter(({ surrounding }) => {
          return surrounding.placeCategory.code !== placeCategoryCode;
        }),
      );
    }
  }

  useEffect(() => {
    handleFilterCheckboxChanges('locality', showCities);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCities]);

  useEffect(() => {
    handleFilterCheckboxChanges('attraction', showAttractions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAttractions]);

  useEffect(() => {
    handleFilterCheckboxChanges('natural_feature', showBeaches);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBeaches]);

  useEffect(() => {
    handleFilterCheckboxChanges('grocery_or_supermarket', showSuperMarkets);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSuperMarkets]);

  useEffect(() => {
    handleFilterCheckboxChanges('restaurant', showRestaurants);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRestaurants]);

  return (
    <Accordion isOpen={showSights} toggle={toggleSights} label={sights.label}>
      <div className="flex flex-wrap">
        <div className="my-[10px]">
          <SurroundingsMapCheckBox
            id="gm-locality"
            label={sights.cities}
            onChange={() => {
              setShowCities(!showCities);
            }}
            color="#8ead75"
            isSelected={showCities}
            hidden={!containsSurroundingType('locality')}
          />
          <SurroundingsMapCheckBox
            id="gm-attraction"
            label={sights.attractions}
            onChange={() => setShowAttractions(!showAttractions)}
            color="#c26ab2"
            isSelected={showAttractions}
            hidden={!containsSurroundingType('attraction')}
          />
          <SurroundingsMapCheckBox
            id="gm-natural-feature"
            label={sights.beaches}
            onChange={() => setShowBeaches(!showBeaches)}
            color="#ebbf20"
            isSelected={showBeaches}
            hidden={!containsSurroundingType('natural_feature')}
          />
          <SurroundingsMapCheckBox
            id="gm-grocery-or-supermarket"
            label={sights.supermarkets}
            onChange={() => setShowSuperMarkets(!showSuperMarkets)}
            color="#f1a777"
            isSelected={showSuperMarkets}
            hidden={!containsSurroundingType('grocery_or_supermarket')}
          />
          <SurroundingsMapCheckBox
            id="gm-restaurant"
            label={sights.restaurants}
            onChange={() => setShowRestaurants(!showRestaurants)}
            color="#004d9d"
            isSelected={showRestaurants}
            hidden={!containsSurroundingType('restaurant')}
          />
        </div>
      </div>
    </Accordion>
  );
}
